if (!customElements.get('kis-unit-price')) {
  customElements.define('kis-unit-price', class extends HTMLElement {
    connectedCallback() {
      const container = this.closest('.price, .cart-item__price-wrapper');
      if (!container) return;
      const casePrice = container.querySelector(container.classList.contains('cart-item__price-wrapper')
        ? '.price--end:not(s) .money'
        : container.classList.contains('price--on-sale')
          ? '.price-item--sale .money' : '.price__regular .price-item--regular .money');
      if (!casePrice) return;
      const update = () => {
        const unitCents = Number(this.dataset.unitCents);
        const caseCents = Number(this.dataset.caseCents);
        const currency = casePrice.getAttribute('doubly-currency') || this.dataset.currency;
        const displayedCase = Number(casePrice.textContent.replace(/[^0-9.-]/g, ''));
        if (!(caseCents > 0) || !(unitCents >= 0) || !Number.isFinite(displayedCase)) return;
        try {
          this.querySelector('[data-unit-amount]').textContent = new Intl.NumberFormat('en-CA', {
            style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2
          }).format(displayedCase * unitCents / caseCents) + ' ' + currency;
        } catch (_) {
          // Keep the server-rendered unit price if the currency format is unavailable.
        }
      };
      update();
      this.observer = new MutationObserver(update);
      this.observer.observe(casePrice, { attributes: true, characterData: true, childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
